export default __webpack_public_path__ + "static/media/03-servers.74104488.png";